import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './router/interceptor';
import axios from './setup/request';
import { i18n } from './setup/i18n';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/iconfont/iconfont.css';
import 'leaflet/dist/leaflet.css';

// 图片预览组件
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';
Vue.use(Viewer);

Vue.config.productionTip = Vue.config.devtools = Vue.config.performance =
  process.env.NODE_ENV !== 'production';

const errorHandler = async (e) => {
  if (e && e.message && e.message !== 'ResizeObserver loop limit exceeded') {
    console.error(e.message);
  }
  if (Vue.config.productionTip) {
    console.error(e); // eslint-disable-line no-console
  }
};
Vue.config.errorHandler = errorHandler;
window.addEventListener('unhandledrejection', (event) => {
  event.preventDefault();
  errorHandler(event.reason || event);
});
window.addEventListener('error', (event) => {
  event.preventDefault();
  errorHandler(event.error || event);
});

Vue.prototype.$http = axios;

Vue.use(ElementUI);

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
